"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getAllQueryString$ge;

exports.debounce = debounce;
exports.throttle = throttle;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * [getQueryString 获取url参数]
 *
 * @return  {[type]}  [return xxx=xxx&xxx=xxx]
 */
var getAllQueryString = exports.getAllQueryString = function getAllQueryString() {
    var url = document.location.toString();
    var arrUrl = url.split("?");
    var para = arrUrl[1];
    return para;
};
/**
 * [getQueryString 获取指定url参数]
 *
 * @param   {[String]}  name  [name 参数key]
 *
 * @return  {[type]}        [return description]
 */
var getQueryString = exports.getQueryString = function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};
/**
 * [formatFileSize B转换到KB,MB,GB]
 *
 * @param   {[type]}  fileSize  [fileSize 文件大小]
 * @param   {[type]}  num  [num 保留小数位数]
 *
 * @return  {[type]}            [return description]
 */
var formatFileSize = exports.formatFileSize = function formatFileSize(fileSize) {
    var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var temp = void 0;
    if (fileSize < 1024) {
        return fileSize + 'B';
    } else if (fileSize < 1024 * 1024) {
        temp = fileSize / 1024;
        temp = temp.toFixed(num);
        return temp + 'KB';
    } else if (fileSize < 1024 * 1024 * 1024) {
        temp = fileSize / (1024 * 1024);
        temp = temp.toFixed(num);
        return temp + 'MB';
    } else {
        temp = fileSize / (1024 * 1024 * 1024);
        temp = temp.toFixed(num);
        return temp + 'GB';
    }
};

/**
 * [base64ToFile base64转file]
 *
 * @param   {[type]}  base64    [base64 description]
 * @param   {[type]}  filename  [filename 文件名]
 *
 * @return  {[type]}            [return description]
 */
var base64ToFile = exports.base64ToFile = function base64ToFile(base64, filename) {
    var arr = base64.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var suffix = mime.split('/')[1]; // 图片后缀
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename + "." + suffix, { type: mime });
};

/**
 * [base64ToBlob base64转blob]
 *
 * @param   {[type]}  base64    [base64 description]
 *
 * @return  {[type]}            [return description]
 */
var base64ToBlob = exports.base64ToBlob = function base64ToBlob(base64) {
    var arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};

/**
 *  blob转file
 *  @param { blob } blob
 *  @param { string } fileName
 */
var blobToFile = exports.blobToFile = function blobToFile(blob, fileName) {
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return blob;
};

/**
 * file转base64
 * @param { * } file 图片文件
 */
var fileToBase64 = exports.fileToBase64 = function fileToBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        return e.target.result;
    };
};
/**
   * [urlToBlob url转blob]
   *
   * @param   {[type]}  fileUrl  [fileUrl]
   * @param   {[type]}  fileType  [fileType]
   *
   * @return  {[type]}           [return description]
   */
var urlToBlob = exports.urlToBlob = function urlToBlob(fileUrl) {
    var fileType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", fileUrl);
        xhr.responseType = "blob";
        xhr.onload = function () {
            var content = xhr.response;
            var blob = new Blob([content], { type: fileType });
            resolve(blob);
        };
        xhr.send();
    });
};
/**
 * @desc 函数防抖
 * @param { function } func
 * @param { number } wait 延迟执行毫秒数
 * @param { boolean } immediate  true 表立即执行，false 表非立即执行
 */
function debounce(func, wait, immediate) {
    var timeout = void 0;
    return function () {
        var context = this;
        var args = arguments;

        if (timeout) clearTimeout(timeout);
        if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(function () {
                timeout = null;
            }, wait);
            if (callNow) func.apply(context, args);
        } else {
            timeout = setTimeout(function () {
                func.apply(context, args);
            }, wait);
        }
    };
}

/**
 * @desc 函数节流
 * @param { function } func 函数
 * @param { number } delay 延迟执行毫秒数
 */
function throttle(fun, delay) {
    var last = void 0,
        deferTimer = void 0;
    return function (args) {
        var that = this;
        var _args = arguments;
        var now = +new Date();
        if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fun.apply(that, _args);
            }, delay);
        } else {
            last = now;
            fun.apply(that, _args);
        }
    };
}

exports.default = (_getAllQueryString$ge = {
    getAllQueryString: getAllQueryString,
    getQueryString: getQueryString,
    formatFileSize: formatFileSize,
    base64ToFile: base64ToFile,
    base64ToBlob: base64ToBlob,
    blobToFile: blobToFile,
    fileToBase64: fileToBase64
}, _defineProperty(_getAllQueryString$ge, "getQueryString", getQueryString), _defineProperty(_getAllQueryString$ge, "debounce", debounce), _defineProperty(_getAllQueryString$ge, "throttle", throttle), _defineProperty(_getAllQueryString$ge, "urlToBlob", urlToBlob), _getAllQueryString$ge);